import { render, staticRenderFns } from "./MainContentSupport.vue?vue&type=template&id=582e0bf1&scoped=true&lang=pug&"
import script from "./MainContentSupport.vue?vue&type=script&lang=js&"
export * from "./MainContentSupport.vue?vue&type=script&lang=js&"
import style0 from "./MainContentSupport.vue?vue&type=style&index=0&id=582e0bf1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582e0bf1",
  null
  
)

export default component.exports